import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import thumbUpImg from "../images/icons8-thumbs-up-50.png";
import { ArrowLeft, CheckCircle } from "lucide-react";

const ThankYouEducation = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if (window.fbq) {
            window.fbq('init', '1645354449933872');
            window.fbq('track', 'Lead');
        }
    }, []);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen relative overflow-hidden bg-slate-50 font-poppins selection:bg-[#3E88FF] selection:text-white px-4">

            <div className="absolute top-[-10%] left-[-10%] w-[40rem] h-[40rem] bg-[#3E88FF] rounded-full mix-blend-multiply filter blur-[100px] opacity-10 pointer-events-none"></div>

            <div className="max-w-2xl w-full bg-white p-10 md:p-14 rounded-[2rem] shadow-[0_8px_40px_rgba(0,0,0,0.04)] border border-slate-100 relative z-10 flex flex-col items-center text-center">
                <h1 className="text-3xl font-anton tracking-widest cursor-pointer mb-10 flex items-baseline" onClick={() => navigate("/")}>
                    DUMOSH<span className="h-2 w-2 bg-[#FF3E3E] rounded-full ml-1"></span>
                </h1>
                <div className="w-20 h-20 bg-emerald-50 text-emerald-500 rounded-full flex items-center justify-center mb-8 shadow-inner border border-emerald-100">
                    <CheckCircle className="w-10 h-10" />
                </div>

                <h1 className="text-4xl md:text-5xl font-black text-slate-800 tracking-tight mb-4">
                    Submission Successful
                </h1>
                <p className="text-lg md:text-xl text-slate-500 mb-10 max-w-lg">
                    Thank you for providing your details. Our EdTech experts are reviewing your application and will be in touch shortly.
                </p>

                <div className="w-full bg-slate-50/80 p-6 md:p-8 rounded-2xl text-left border border-slate-100 mb-8">
                    <div className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-6">What happens next</div>

                    <div className="relative border-l-2 border-slate-200 ml-3 space-y-8 pb-2">
                        <div className="relative pl-6">
                            <div className="absolute w-4 h-4 bg-[#3E88FF] rounded-full -left-[9px] top-1 shadow-[0_0_0_4px_white]"></div>
                            <h4 className="font-bold text-slate-800 text-base mb-1">Expert Outreach</h4>
                            <p className="text-slate-500 text-sm">You'll receive a call or WhatsApp message from a dedicated DUMOSH expert.</p>
                        </div>
                        <div className="relative pl-6">
                            <div className="absolute w-4 h-4 bg-slate-300 rounded-full -left-[9px] top-1 shadow-[0_0_0_4px_white]"></div>
                            <h4 className="font-bold text-slate-800 text-base mb-1">Goal Alignment</h4>
                            <p className="text-slate-500 text-sm">We'll perform a deep-dive to understand your goals and current ad funnel.</p>
                        </div>
                        <div className="relative pl-6">
                            <div className="absolute w-4 h-4 bg-slate-300 rounded-full -left-[9px] top-1 shadow-[0_0_0_4px_white]"></div>
                            <h4 className="font-bold text-slate-800 text-base mb-1">Conversion Plan</h4>
                            <p className="text-slate-500 text-sm">We'll share a clear, tailored action plan designed to improve your admissions conversions.</p>
                        </div>
                    </div>
                </div>

                <div className="bg-[#3E88FF]/10 text-[#3E88FF] font-medium py-3 px-6 rounded-lg text-sm w-full mb-8 border border-[#3E88FF]/20 flex items-center justify-center">
                    <strong className="mr-1">Pro tip:</strong> Keep your phone available to speed things up.
                </div>

                <button
                    className="w-full px-8 py-4 bg-white border-2 border-slate-200 text-slate-700 rounded-xl hover:bg-slate-50 hover:border-slate-300 hover:text-slate-900 transition-all duration-300 font-bold text-md flex items-center justify-center group"
                    onClick={() => navigate("/interactive-education")}
                >
                    <ArrowLeft className="w-4 h-4 mr-2 group-hover:-translate-x-1 transition-transform" /> Back to Assessment
                </button>
            </div>
        </div>
    );
};

export default ThankYouEducation;
